export const COL_HEADER_MAX_LENGTH = 32;
export const COL_CONTENT_MAX_LENGTH = 64;
